function upload(number) {
  window.addEventListener('DOMContentLoaded', function () {
    document.querySelector(`#file_upload${number}`).addEventListener('change', function (e) {
      console.log('test');
      const upload = document.getElementById(`file_upload${number}`);
      const result = document.getElementById(`file_name${number}`);
      const cancel = document.getElementById(`file_clear${number}`);
      const target = document.querySelector(`#file${number}`);

      if (target) {
        target.remove();
      }

      // ファイル名生成
      const text = document.createElement('p');
      text.classList.add('p-index_fileName');
      text.id = `file${number}`;
      text.innerText = upload.files[0].name;
      // 削除ボタンの前に挿入
      result.insertBefore(text, cancel);
      cancel.style.display = 'block';
      // アップロードボタンを非活性
      //upload.disabled = true;
      //const label = upload.parentNode;
      //label.classList.add('p-index_disabled');
    });
  });
}

export function fileUpload1() {
  upload(1);
}

export function fileUpload2() {
  upload(2);
}

export function fileUpload3() {
  upload(3);
}

export function fileUpload4() {
  upload(4);
}

export function fileUpload5() {
  upload(5);
}

export function fileUpload6() {
  upload(6);
}

export function fileUpload7() {
  upload(7);
}

export function fileUpload8() {
  upload(8);
}

export function fileUpload9() {
  upload(9);
}

export function fileUpload10() {
  upload(10);
}
